import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import Switch from "react-bootstrap-switch";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Modal, Row} from "reactstrap";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {itineraryService} from "../../../../jwt/_services/eventx/ItineraryService";
import {TT_CLOSE, TT_DELETE, TT_SAVE} from "../../../../components/i18n/toolTips";
import {FORM,  LB_ACTIVE} from "../../../../components/i18n/i18n";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {categoryProvider} from "../../../../providers/categoryProvider";
import {activityProvider} from "../../../../providers/activityProvider";
import {GenericButton} from "../../../../components/buttons/customButtons";
import Separator from "../../../../components/Separator";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";
import {placeProvider} from "../../../../providers/placeProvider";
import moment from "moment/moment";
import {paxProvider} from "../../../../providers/clasificators/paxProvider";



// components

// labels

// actions

// services

// providers


export const ActivityItinerarySectionForm = forwardRef((props, ref) => {
    const path = props.path + "/itinerary";
    const [udn] = useState(props.udn || null);
    const [app] = useState(props.app || null);
    const [event] = useState(props.event || null);
    const [parent] = useState(props.activity || null);
    const [category] = useState(props.category || null);

    const [domainObject, setDomainObject] = useState(null);

    const [status, setStatus] = useState( domainObject?.status !== undefined ? domainObject?.status : true);

    const [hourStart, setHourStart] = useState(  '' )
    const [hourEnd, setHourEnd] = useState(  '' )
    const [date, setDate] = useState(  '' )

    const [categoryId, setCategoryId] = useState(  category?.id || null);
    const [activityId, setActivityId] = useState(  parent?.id || null);

    const [placeId, setPlaceId] = useState(  domainObject?.place?.id || null);
    const [paxId, setPaxId] = useState( domainObject?.pax?.id || null);

    const [modal, setModal] = useState(false);

    const [showHistoryModal, setShowHistoryModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowHistoryModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            date: domainObject?.date,
            duration: props.activity?.capacity || domainObject?.duration,
            timeStart: domainObject?.timeStart,
            timeEnd: domainObject?.timeEnd,
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase :  { id : app?.fbDataBase?.id },
            item : {
                date: date,
                timeStart: hourStart,
                timeEnd: hourEnd,
                duration : props.activity?.capacity || '',
                status,
                event : { id : props.event?.id },
                activity : { id: props.activity?.id },
                category : { id : props.category?.id },
            }
        };

        if (placeId != null)
            dataRequest.item.place = { id : placeId };

        if (paxId != null)
            dataRequest.item.pax = { id : paxId };

        if (domainObject?.id !== undefined) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, itineraryService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, itineraryService, dataRequest)
        }

        closeModal();
    };

    const confirmDelete = () => {
        genericIndexedActions.delete(path, itineraryService, domainObject?.id, app?.fbDataBase?.id)
    }

    const closeModal = () => {
        setModal(!modal);
        setDate('');
        setHourStart('');
        setHourEnd('');
        setStatus(null);
        setCategoryId(null);
        setActivityId(null);
        setPlaceId(null);
        setPaxId(null);
        setDomainObject(null);
        reset();
    }

    const showModal = () => {
        setModal(!modal);
    }

    useImperativeHandle(ref, () => ({
        showModal(_item, _start, _end) {
            if (_item?.id !== undefined) {
                setDomainObject(_item);
                setDate(_item?.date || '')
                setHourStart(_item?.timeStart || '');
                setHourEnd(_item?.timeEnd || '');
            } else {
                const formated = moment(_start).format("YYYY-MM-DD")
                setDomainObject(null);
                setDate(formated || '');
                setHourStart(moment(_start).format("HH:mm") || '');
                setHourEnd(moment(_end).format("HH:mm") || '');
                //const end = moment(_start).add(props?.activity?.capacity, 'minutes').format("HH:mm")
                //setHourEnd(end  || '');
            }

            setStatus(_item?.status!=null ? _item.status : true);
            setCategoryId(_item?.category?.id || null);
            setActivityId(_item?.activity?.id || null);
            setPlaceId(_item?.place?.id || null);
            setPaxId(_item?.pax?.id || null);
            setModal(!modal);
        }
    }));

    const handleHourStart = (e) => {
        const value = e.target.value
        setHourStart( value )

        /*
        // Convertir la hora a un objeto Date
        const [hours, minutes] = value.split(':');
        const date = new Date();
        date.setHours(parseInt(hours));
        date.setMinutes(parseInt(minutes));

        // Sumar 20 minutos
        date.setMinutes(date.getMinutes() + parseInt(props.activity?.capacity));

        // Convertir de nuevo a cadena de texto en formato HH:mm
        const newEnd = date.toTimeString().slice(0, 5);
        setHourEnd(newEnd  || '');
        */
    }

    return <Modal isOpen={modal} toggle={showModal} modalClassName="menu-modal-form">
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0 modal-title">
                <i className="far fa-edit mr-2"/>{FORM}
                <br/>
                <h5 className={'card-modal-uid'}> {'     uid: ' + domainObject?.uid}</h5>
                <div className="top-right">
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        onClick={onSubmit}
                    />
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_DELETE}
                        icon={'fa-trash'}
                        permission={'delete'}
                        onClick={confirmDelete}
                    />
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={_ => setModal(false)}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col md="9">
                        <FormGroup>
                            <Label>{ 'Foro' }</Label>
                            <SelectGeneric
                                initialValue={ placeId }
                                setExternalValue={ value =>  setPlaceId(value) }
                                provider = { placeProvider }
                                customFilter={{
                                    onlyRegistered: true,
                                    fbDataBase :  { id : app?.fbDataBase?.id },
                                    item: { udn: {id: udn?.id } }
                                }}
                                resetValue={ false }

                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{LB_ACTIVE}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={ status }
                                onChange={ _ => setStatus(!status) }
                            />

                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup>
                            <Label>{ 'Fecha' }</Label>
                            <Input type="date"
                                   name="date"
                                   value={ date }
                                   onChange={ e => setDate( e.target.value ) }
                                   placeholder={ 'Fecha' }
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Hora de inicio</Label>
                            <Input
                                type="time"
                                name="timeStart"
                                value={ hourStart }
                                onChange={ handleHourStart }
                                innerRef={ register }
                                placeholder="Ingrese hora"
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Hora de fin</Label>
                            <Input
                                type="time"
                                name="timeEnd"
                                value={ hourEnd }
                                onChange={ e => setHourEnd( e.target.value ) }
                                innerRef={ register }
                                placeholder="Ingrese hora"
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{ 'Duración' }</Label>
                            <Input
                                type="text"
                                name="duration"
                                innerRef={ register }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>

                    {/*<Col>*/}
                    {/*    <FormGroup>*/}
                    {/*        <Label>{ 'Anfitrion' }</Label>*/}
                    {/*        <SelectGeneric*/}
                    {/*            initialValue={ paxId }*/}
                    {/*            setExternalValue={ value =>  setPaxId(value) }*/}
                    {/*            provider = { paxProvider }*/}
                    {/*            customFilter={{*/}
                    {/*                onlyRegistered: true,*/}
                    {/*                fbDataBase :  { id : app?.fbDataBase?.id },*/}
                    {/*                item: { }*/}
                    {/*            }}*/}
                    {/*            resetValue={ false }*/}
                    {/*        />*/}
                    {/*    </FormGroup>*/}
                    {/*</Col>*/}
                </Row>
                <Row>
                    {/*<Col>*/}
                    {/*    <FormGroup>*/}
                    {/*        <Label>{ 'Genero' }</Label>*/}
                    {/*        <SelectGeneric*/}
                    {/*            initialValue={categoryId}*/}
                    {/*            setExternalValue={value => setCategoryId(value)}*/}
                    {/*            provider={categoryProvider}*/}
                    {/*            resetValue={false}*/}
                    {/*            customFilter={{*/}
                    {/*                onlyRegistered: true,*/}
                    {/*                fbDataBase :  { id : app?.fbDataBase?.id },*/}
                    {/*                item: { udn: {id: udn?.id }}*/}
                    {/*            }}*/}
                    {/*            isDisabled={true}*/}
                    {/*        />*/}
                    {/*    </FormGroup>*/}
                    {/*</Col>*/}
                    {/*<Col>*/}
                    {/*    <FormGroup>*/}
                    {/*        <Label>{ 'Actividad' }</Label>*/}
                    {/*        <SelectGeneric*/}
                    {/*            initialValue={ activityId }*/}
                    {/*            setExternalValue={ value =>  setActivityId(value) }*/}
                    {/*            provider = { activityProvider }*/}
                    {/*            customFilter={{*/}
                    {/*                onlyRegistered: true,*/}
                    {/*                fbDataBase :  { id : app?.fbDataBase?.id },*/}
                    {/*                item: {*/}
                    {/*                    udn: {id: udn?.id },*/}
                    {/*                    status : null,*/}
                    {/*                    isExtraordinary: false*/}
                    {/*                }*/}
                    {/*            }}*/}
                    {/*            resetValue={ false }*/}
                    {/*            isDisabled={true}*/}
                    {/*        />*/}
                    {/*    </FormGroup>*/}
                    {/*</Col>*/}
                </Row>

                <br />
                <br />
                <br />
                <br />
                <br />
            </CardBody>
        </Card>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </Modal>
})
